$(document).ready(function () {
	if (!App.city_setted) {
		$('#modal-city').modal('show');
	}
});
